import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Form, Button, Card } from 'react-bootstrap';
import axios from 'axios';
import MessageBox from '../components/MessageBox';

export default function ForgotPasswordScreen() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post('/api/users/forgot-password', { email });
      setMessage(data.message);
      setError('');
    } catch (err) {
      setError(
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
      );
      setMessage('');
    }
  };

  return (
    <Card className="mx-auto my-5" style={{ maxWidth: '400px' }}>
      <Card.Body>
        <Helmet>
          <title>Forgot Password</title>
        </Helmet>
        <h2 className="mb-3">Forgot Password</h2>
        {message && <MessageBox variant="success">{message}</MessageBox>}
        {error && <MessageBox variant="danger">{error}</MessageBox>}
        <Form onSubmit={submitHandler}>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Group>
          <div className="d-grid">
            <Button type="submit" variant="primary">
              Send Reset Link
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}